var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('app-tabela',{attrs:{"itens":_vm.contrato.ocorrenciasGerais,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"heading-1 mb-4"},[_c('span',[_vm._v("OCORRÊNCIAS")])])
}]

export { render, staticRenderFns }